import React from 'react';
import { connect } from 'react-redux';
import { arrayOf, bool, number, object, shape, string } from 'prop-types';
import { LazyAddTrustedFreelancerToOrganization, AddTrustedFreelancerToOrganizationThemes } from '@fiverr-private/business_blocks';
import ExpertProfile from './ExpertProfile';
import ContactExpert from './ContactExpert';

import './style.scss';

const ExpertCard = ({
    isPro,
    sellerName,
    countryCode,
    proficientLanguages,
    profilePhoto,
    notableClients,
    translationFlag = false,
    repeatScore,
    isTrustedFreelancer
}) => (
    <div className="expert">
        <ExpertProfile isPro={isPro}
            sellerName={sellerName}
            countryCode={countryCode}
            profilePhoto={profilePhoto}
            proficientLanguages={proficientLanguages}
            notableClients={notableClients}
            translationFlag={translationFlag}
            repeatScore={repeatScore}/>
        <div className="action-button flex">
            <LazyAddTrustedFreelancerToOrganization className="m-l-16"
                freelancer={{ username: sellerName, name: sellerName }}
                isTrustedByOrganization={isTrustedFreelancer}
                theme={AddTrustedFreelancerToOrganizationThemes.darkWithoutBorder}/>
            <ContactExpert/>
        </div>
    </div>
);

ExpertCard.propTypes = {
    isPro: bool,
    countryCode: string,
    proficientLanguages: arrayOf(
        shape({
            name: string,
            level: number
        })
    ),
    profilePhoto: string,
    sellerName: string,
    notableClients: arrayOf(object),
    translationFlag: bool,
    repeatScore: shape({
        score: bool
    }),
    isTrustedFreelancer: bool
};

const mapStateToProps = ({ ugc }) => ({
    translationFlag: !ugc.showOriginal
});

const ConnectedExpertCard = connect(mapStateToProps)(ExpertCard);

export { ExpertCard };
export default ConnectedExpertCard;
